import { Paper, Stack, Typography } from '@mui/material';
import ChevronLeftRounded from '@mui/icons-material/ChevronLeftRounded';
import ChevronRightRounded from '@mui/icons-material/ChevronRightRounded';
import EastRounded from '@mui/icons-material/EastRounded';
import { Button } from '../../../../Components/MUIs';

/**
 * PDF/문서 뷰어 하단: 이전·페이지·다음(완료) + (선택) 다음 단계 건너뛰기
 */
export default function DocumentPaginationBar({
  pageNumber,
  numPages,
  goToPrevPage,
  goToNextPage,
  onAdvanceStep,
  onSkipToNextStep,
  skipToNextStepLabel = '다음 단계',
  disabled = false,
}) {
  const HandlePrimaryNext = () => {
    if (disabled) return;
    if (numPages > 0 && pageNumber < numPages) {
      goToNextPage();
      return;
    }
    onAdvanceStep();
  };

  return (
    <Stack spacing={2} sx={{ width: '100%', p: 2 }}>
      <Paper
        elevation={0}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1,
          p: 1.25,
          borderRadius: 3,
          bgcolor: '#f4f6f8',
          border: '1px solid',
          borderColor: 'rgba(0, 0, 0, 0.06)',
        }}
      >
        <Button
          variant="outlined"
          color="inherit"
          name={
            <Stack direction="row" alignItems="center" spacing={0.25}>
              <ChevronLeftRounded sx={{ fontSize: 24, color: '#5c5c5c' }} />
              <Typography
                component="span"
                sx={{ fontSize: 14, fontWeight: 600, color: '#424242' }}
              >
                이전
              </Typography>
            </Stack>
          }
          sx={{
            flex: '1 1 0',
            minWidth: 0,
            maxHeight: 44,
            py: 1,
            borderRadius: 2.5,
            borderColor: 'rgba(0, 0, 0, 0.1)',
            bgcolor: '#fff',
            '&:hover': {
              bgcolor: '#fafafa',
              borderColor: 'rgba(0, 0, 0, 0.18)',
            },
          }}
          onClick={goToPrevPage}
        />

        <Typography
          component="div"
          sx={{
            flex: '0 0 auto',
            px: 2,
            py: 0.75,
            borderRadius: 999,
            bgcolor: '#fff',
            fontSize: 13,
            fontWeight: 700,
            color: '#333',
            letterSpacing: '0.04em',
            whiteSpace: 'nowrap',
            border: '1px solid',
            borderColor: 'rgba(0, 0, 0, 0.06)',
            boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
          }}
        >
          {numPages > 0 ? `${pageNumber} / ${numPages}` : '—'}
        </Typography>

        <Button
          variant="contained"
          disableElevation
          name={
            <Stack direction="row" alignItems="center" spacing={0.25}>
              <Typography component="span" sx={{ fontSize: 14, fontWeight: 600 }}>
                {pageNumber === numPages ? '완료' : '다음'}
              </Typography>
              <ChevronRightRounded sx={{ fontSize: 24 }} />
            </Stack>
          }
          sx={{
            flex: '1 1 0',
            minWidth: 0,
            maxHeight: 44,
            py: 1,
            borderRadius: 2.5,
            background: 'linear-gradient(180deg, #1976d2 0%, #1565c0 100%)',
            '&:hover': {
              background: 'linear-gradient(180deg, #1e88e5 0%, #1976d2 100%)',
            },
          }}
          disabled={disabled}
          onClick={HandlePrimaryNext}
        />
      </Paper>

      {typeof onSkipToNextStep === 'function' && (
        <Button
          variant="outlined"
          color="primary"
          fullWidth
          disabled={disabled}
          name={
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="center"
              spacing={1}
            >
              <EastRounded sx={{ fontSize: 22, opacity: 0.9 }} />
              <Typography sx={{ fontSize: 15, fontWeight: 600 }}>
                {skipToNextStepLabel}
              </Typography>
            </Stack>
          }
          sx={{
            height: 48,
            borderRadius: 3,
            borderWidth: 2,
            borderStyle: 'dashed',
            borderColor: 'primary.light',
            bgcolor: 'rgba(25, 118, 210, 0.04)',
            '&:hover': {
              borderWidth: 2,
              borderStyle: 'dashed',
              bgcolor: 'rgba(25, 118, 210, 0.08)',
            },
          }}
          onClick={disabled ? undefined : onSkipToNextStep}
        />
      )}
    </Stack>
  );
}
